import { takeEvery, takeLatest } from 'redux-saga/effects';
import { FILTER_TEMPLATE_MODULE } from '../../../configs/moduleNames';
import {
  CREATE_FILTER_TEMPLATE,
  DELETE_FILTER_TEMPLATE,
  LOAD_FILTER_TEMPLATE_BY_ID,
  LOAD_FILTER_TEMPLATE_LIST,
  UPDATE_FILTER_TEMPLATE,
} from '../actions';
import loadFilterTemplateList from './loadFilterTemplateList';
import loadFilterTemplateById from './loadFilterTemplateById';
import createFilterTemplate from './createFilterTemplate';
import updateFilterTemplate from './updateFilterTemplate';
import deleteFilterTemplate from './deleteFilterTemplate';

export default function* watchClient() {
  yield takeLatest(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_LIST, loadFilterTemplateList);
  yield takeEvery(FILTER_TEMPLATE_MODULE + LOAD_FILTER_TEMPLATE_BY_ID, loadFilterTemplateById);
  yield takeEvery(FILTER_TEMPLATE_MODULE + CREATE_FILTER_TEMPLATE, createFilterTemplate);
  yield takeEvery(FILTER_TEMPLATE_MODULE + UPDATE_FILTER_TEMPLATE, updateFilterTemplate);
  yield takeEvery(FILTER_TEMPLATE_MODULE + DELETE_FILTER_TEMPLATE, deleteFilterTemplate);
}
